import { render, staticRenderFns } from "./RealTimeView.vue?vue&type=template&id=b56b5d24&scoped=true"
import script from "./RealTimeView.vue?vue&type=script&lang=js"
export * from "./RealTimeView.vue?vue&type=script&lang=js"
import style0 from "./RealTimeView.vue?vue&type=style&index=0&id=b56b5d24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56b5d24",
  null
  
)

export default component.exports